'use strict';

import {
    useMemo
} from 'react';

import {
    useCurationConfigValue,
    useCurationConfigState
} from '../../../hooks/widgetConfiguration.js';

import {
    useLoadLandscapeListeningQuery,
    useListLandscapeSavedSearches,
    useGetListeningQueryDisplayName
} from './useListeningQueryPersistence.js';

const BaseCurationTitle = 'Listening';

export default function useGetCurationTitle(baseTitle = BaseCurationTitle) {

    const [listeningQueryId, setListeningQueryId] = useCurationConfigState('listeningQueryId');
    const showAdvancedSearchEditor = useCurationConfigValue('showAdvancedSearchEditor');

    const {data: listeningQuery} = useLoadLandscapeListeningQuery(listeningQueryId);
    const searchDisplayName = useGetListeningQueryDisplayName(listeningQuery, listeningQueryId);
    const {data: allLandscapeSavedSearches} = useListLandscapeSavedSearches();

    const listeningQueryTitleView = useMemo(() => {
        if (!listeningQuery) {
            return;
        }

        if (listeningQuery?.listeningQueryTypeId === RivalIQ.enums.listeningQueryTypes.QuidTopic.id) {
            return `Quid Monitor Topics / ${searchDisplayName}`;
        }

        const collectionItems = _.map(allLandscapeSavedSearches, (search) => {
            return {
                id: search.id,
                display: search.name,
                action: () => {
                    setListeningQueryId(search.id);
                }
            };
        });

        return () => {
            // we're using Marionette here because we're updaing the navigation bar, and the navigation bar is still in the old Marionette world
            return new RivalIQ.views.TitleDropdown({
                model: new Backbone.Model(_.extend({
                    name: `Saved Searches / ${searchDisplayName}`,
                    hasEditButton: true,
                    titleViewEditName: 'Edit Search',
                    editAction: () => {

                        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ListeningClickedEdit, {
                            source: 'navigation-title-dropdown'
                        });

                        RivalIQ.execute('history:navigate', `listening/savedsearchbuilder/${listeningQueryId}`, {
                            trigger: true
                        });
                    }
                })),
                collection: new Backbone.Collection(collectionItems)
            });
        };
    }, [listeningQuery, allLandscapeSavedSearches, setListeningQueryId, listeningQueryId, searchDisplayName]);

    if (listeningQuery) {
        return listeningQueryTitleView;
    } else {
        if (showAdvancedSearchEditor) {
            return 'Edit Instant Search';
        } else {
            return baseTitle;
        }
    }
}
